// extracted by mini-css-extract-plugin
export default {"container":"RelatedEntitiesMatching_container__zfXX8"};